import fm from "front-matter";

export interface BlogFaq {
  question: string;
  answer: string;
}

export interface BlogPost {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  image: string;
  date: string;
  author: string;
  category: string;
  tags: string[];
  faqs?: BlogFaq[];
}

const markdownFiles = import.meta.glob("../content/blog/*.md", {
  eager: true,
  query: "?raw",
  import: "default",
});

const ensureArray = (value: unknown): string[] =>
  Array.isArray(value) ? value.map((item) => String(item)) : [];

const ensureFaqs = (value: unknown): BlogFaq[] =>
  Array.isArray(value)
    ? value.map((qa) => ({
        question: String((qa as any)?.question ?? ""),
        answer: String((qa as any)?.answer ?? ""),
      }))
    : [];

export const blogPosts: BlogPost[] = Object.entries(markdownFiles).map(
  ([filePath, rawContent]) => {
    const { attributes, body } = fm(rawContent as string);

    const slugFromPath =
      filePath.split("/").pop()?.replace(/\.md$/, "") ??
      String((attributes as any)?.slug ?? "");

    return {
      id: Number((attributes as any)?.id ?? 0),
      title: String((attributes as any)?.title ?? ""),
      slug: String((attributes as any)?.slug ?? slugFromPath),
      excerpt: String((attributes as any)?.excerpt ?? ""),
      image: String((attributes as any)?.image ?? ""),
      date: String((attributes as any)?.date ?? ""),
      author: String((attributes as any)?.author ?? ""),
      category: String((attributes as any)?.category ?? ""),
      tags: ensureArray((attributes as any)?.tags),
      faqs: ensureFaqs((attributes as any)?.faqs),
      content: String(body ?? ""),
    };
  }
);

